<mcg-window #window [loading]="loading()" [title]="translate('Listado_tarjetas')" [actions]="actions"
  (actionButtonClicked)="actionButtonClicked($event)" [containerSelector]="'#map-container'"  (windowClosed)="closeWindow()">
  <jqxRibbon #tarjRibbon [theme]="environment.tema" [position]="'top'" [height]="'100%'"
  (onSelect)="tabSelected($event)">
    <ul>
      <li>
        {{ translate('Tarjetas') }} ({{ recordTagetsCount() }})
      </li>
      <li>
        {{ translate('Lista') }} ({{ recordRangesCount() }})
      </li>
    </ul>

    <div>
      <div style="float: left; height: '100%'; width: '100%'; overflow: hidden;">
        <div>
          <app-header #header [exportar]="true" [buscador]="true" [filtro]="true" [resetFiltro]="true"
            [sourceZonas]="zonas" [seeDropModoTarj]="true" [seeZonas]="true"
            (eventChangeModoTarjeta)="onChangeModoTarjeta($event)" (eventChangeZona)="onChangeZona($event)"
            (eventFilter)="eventFilter()" (eventResetFilter)="eventResetFilter()" (eventExportar)="onExportar()"
            (eventBuscador)="onBuscar()">
          </app-header>
        </div>

        <div style="float:left; margin-top: 5px; width: 100%; height: calc(100% - 45px);">
          <jqxGrid #gridTarjetas [theme]="environment.tema" [width]="'100%'" [height]="'100%'"
            [source]="adapterTarjetas" [appCellClick] [columnsresize]="true" [localization]="langGrid"
            [filterable]="true" [columns]="columnsTarjetas" [showrowlines]="false" [showcolumnlines]="true"
            [pageable]="false" [groupsheaderheight]="25" [sortable]="true" [altrows]="true"
            [autoshowloadelement]="true" [autoloadstate]="true" [enablebrowserselection]="true" [rowsheight]="25"
            [groupable]="true" [columnsheight]="20" [groupsrenderer]="groupsrenderer" [editable]="false"
            [filter]="filter" [updatefilterconditions]="updatefilterconditions" (onFilter)="onFilter($event)">
          </jqxGrid>
        </div>
      </div>

      <div style="float: left; height: '100%'; width: '100%'; overflow: hidden;">
        <app-tab-rangos #tabRangos></app-tab-rangos>
      </div>
    </div>
  </jqxRibbon>
</mcg-window>
